
import { IFloatSelectSerialItem } from '../../../../FloatSelectSerial';
import { formatShortDate } from 'utils/formatDatesAndHours';

export const CancelReservationSerialItem = ({ item }: { item: IFloatSelectSerialItem }) => (
  <div className="serialItemContainer">
    <div className="serialItemContent">
      <div className="serialAndProviderContainer">
        <div className="serial">Serial: {item.serial}</div>
        <div className="providerName">Proveedor: {item.providerName}</div>
      </div>
      <div className="billingNumberContainer">
        <div className="billingNumber">Factura: {item.billingNumber}</div>
      </div>
      <div className="dateContainer">
        {item.isFirtsOut && <div className="firstOut">(Primero por salir)</div>}
        <div className="date">Fecha: {formatShortDate(item.date)?.onlyDate ?? ''}</div>
      </div>
    </div>
    <div className="divider isItemList" />
  </div>
);

export default CancelReservationSerialItem;
